/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ session: NonNullable<unknown> }} Plan_Build_Organize_DragInputs */

const en_us2_plan_build_organize_drag = /** @type {(inputs: Plan_Build_Organize_DragInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Drag ${i?.session}`)
};

const pt_br2_plan_build_organize_drag = /** @type {(inputs: Plan_Build_Organize_DragInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Arrastar ${i?.session}`)
};

const es_419_plan_build_organize_drag = /** @type {(inputs: Plan_Build_Organize_DragInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Arrastrar ${i?.session}`)
};

const pt_pt2_plan_build_organize_drag = /** @type {(inputs: Plan_Build_Organize_DragInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Arrastar ${i?.session}`)
};

const fr_fr2_plan_build_organize_drag = /** @type {(inputs: Plan_Build_Organize_DragInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Faire glisser ${i?.session}`)
};

const de_de2_plan_build_organize_drag = /** @type {(inputs: Plan_Build_Organize_DragInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.session} ziehen`)
};

const it_it2_plan_build_organize_drag = /** @type {(inputs: Plan_Build_Organize_DragInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Trascina ${i?.session}`)
};

/**
* | output |
* | --- |
* | "Drag {session}" |
*
* @param {Plan_Build_Organize_DragInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const plan_build_organize_drag = /** @type {((inputs: Plan_Build_Organize_DragInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Build_Organize_DragInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_plan_build_organize_drag(inputs)
	if (locale === "es-419") return es_419_plan_build_organize_drag(inputs)
	if (locale === "pt-PT") return pt_pt2_plan_build_organize_drag(inputs)
	if (locale === "fr-FR") return fr_fr2_plan_build_organize_drag(inputs)
	if (locale === "de-DE") return de_de2_plan_build_organize_drag(inputs)
	if (locale === "it-IT") return it_it2_plan_build_organize_drag(inputs)
	return en_us2_plan_build_organize_drag(inputs)
});
export { plan_build_organize_drag as "plan-build.organize_drag" }